export const LANDING_REDESIGN_2024_FLAG = 'client_pro_landing_page_apo4232_20231214';
export const LANDING_REDESIGN_2024_PERCENT = 0.5;
